module.exports = __webpack_public_path__ + "img/logo.dc1ba4fb.png";